import app from 'flarum/forum/app';

// champis-species' own helper (pretty /species/:id/:slug), else its plain
// /species/:id - the same page either way.
export default function speciesUrl(gbifId, canonicalName) {
  const helper = app.route.species;
  return helper ? helper(gbifId, canonicalName) : app.route('species.legacy', {
    id: gbifId
  });
}
flarum.reg.add('champis-exhibitions', 'forum/utils/speciesUrl', speciesUrl);